import { render, staticRenderFns } from "./RestaurantAddModal.vue?vue&type=template&id=0129faf3&"
import script from "./RestaurantAddModal.vue?vue&type=script&lang=js&"
export * from "./RestaurantAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports